<com-web-dialog dialogTitle="Reset Password" [hasDialogActions]="true">
    <div comWebLoadingOverlay class="min-h-[115px]">
        <com-web-form
            [doShowFormActions]="false"
            [formGroup]="formGroup"
            class="flex flex-col">
            <com-web-input
                sideLabel="Temporary Password"
                controlName="newPassword"
                [disabled]="true"
                [sideLabelWidth]="200"
                [doAllowCopy]="true"
                [inputWidth]="300"></com-web-input>
        </com-web-form>
        <div class="border-1 border-solid bg-blue-100 p-2 h-fit text-blue-800">
            <i class="fa-solid fa-circle-info pr-2"></i
            ><b>Note: This is a temporary password.</b> The user will be
            prompted to reset it the next time they log in.
        </div>
    </div>

    <div footer class="flex flex-row w-full justify-end">
        <com-web-button
            [buttonType]="ButtonType.Cancel"
            (click)="cancel()"></com-web-button>
        <com-web-button
            [buttonType]="ButtonType.Save"
            (click)="submit()"></com-web-button>
    </div>
</com-web-dialog>
